export default __webpack_public_path__ + "static/media/link.bde328e0.svg";